/* eslint-disable @typescript-eslint/naming-convention */
import { StrictOmit } from '@enmon/commons';
import { Descriptions } from 'antd';
import { deviceCategoryTranslated, mountingTranslated } from 'components/Form/meter_details/constants';
import { FormattedMessage, IntlShape } from 'react-intl';
import { MeterDetailElectricity } from '@enmon/commons/lib/enmon';
import { MeterDetails as messages } from './messages';

export type ElectricityDescriptionsDetails = StrictOmit<MeterDetailElectricity, 'width'> & {
  width: { value: MeterDetailElectricity['width']; unit?: string } | null;
};

export const getElectricityDetailDescriptions = (
  details: ElectricityDescriptionsDetails | undefined,
  intl: IntlShape,
) => {
  const {
    isDirect,
    phases,
    inputSpec,
    deviceCategory,
    measurementCategory,
    mounting,
    measuringCurrentTransformer,
    tariffs,
    iMax,
    iMin,
    iRef,
    circuitBreakerSize,
    width,
  } = details ?? {};

  return (
    <>
      <Descriptions.Item label={<FormattedMessage {...messages.deviceType} />}>
        {deviceCategory ? intl.formatMessage(deviceCategoryTranslated[deviceCategory]) : ''}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.measurementCategory} />}>
        {measurementCategory}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.directElectricityMeter} />}>
        {isDirect ? <FormattedMessage {...messages.direct} /> : <FormattedMessage {...messages.indirect} />}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.mtp} />}>
        {measuringCurrentTransformer}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.numberOfPhases} />}>{phases}</Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.mounting} />}>
        {mounting && intl.formatMessage(mountingTranslated[mounting])}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.width} />}>
        {width?.value && `${width?.value} ${width?.unit ?? 'mm'}`}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.tariffs} />}>{tariffs}</Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.minimumCurrent} />}>
        {iMin && `${iMin} A`}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.referenceCurrent} />}>
        {iRef && `${iRef} A`}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.maximumCurrent} />}>
        {iMax && `${iMax} A`}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.reservedPower} />}>
        {circuitBreakerSize && `${circuitBreakerSize} A`}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.inputSpecification} />}>{inputSpec}</Descriptions.Item>
    </>
  );
};
